// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getCustomerCreditInformation } from "@bg/App/Services/CreditCheckService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

interface Props {
    apiParameter: any;
    apiResult: {
        erpNumber: string;
        showSoftHoldWarningMessage: boolean;
        showHardHoldWarningMessage: boolean;
        successful: boolean;
        error?: any;
    };
}

type Parameter = {
    onSuccess?: (result: any) => void;
    onError?: (e: any) => void;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getCustomerCreditInformation();
};

export const onSuccess: HandlerType = props => {
    if (props.apiResult && props.apiResult.successful) {
        const message = {
            showSoftHoldWarningMessage: props.apiResult.showSoftHoldWarningMessage as any,
            showHardHoldWarningMessage: props.apiResult.showHardHoldWarningMessage as any,
        };
        props.parameter.onSuccess?.(message);
    }
};
``;

export const OnError: HandlerType = props => {
    if (props.apiResult && !props.apiResult.successful) {
        const message = {
            showSoftHoldWarningMessage: props.apiResult.showSoftHoldWarningMessage as any,
            showHardHoldWarningMessage: props.apiResult.showHardHoldWarningMessage as any,
        };
        props.parameter.onError?.(message);
    }
};

export const chain = [PopulateApiParameters, RequestDataFromApi, onSuccess, OnError];

const getCustomerCreditData = createHandlerChainRunner(chain, "GetCustomerCreditData");
export default getCustomerCreditData;
